<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="28" viewBox="0 0 24 28" fill="none">
    <path
      d="M16.5 0l7 7v15.6c0 2.25 0 3.375-.573 4.164a3 3 0 0 1-.663.663C21.475 28 20.349 28 18.1 28H5.9c-2.25 0-3.375 0-4.164-.573a3 3 0 0 1-.663-.663C.5 25.975.5 24.849.5 22.6V5.4c0-2.25 0-3.375.573-4.164a3 3 0 0 1 .663-.663C2.525 0 3.651 0 5.9 0h10.6z"
      fill="url(#paint0_linear_1707_59235)"
    />
    <path
      d="M16.5 0l7 7h-3.8c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C16.5 5.48 16.5 4.92 16.5 3.8V0z"
      fill="#fff"
      fill-opacity=".55"
    />
    <path
      d="M8.654 16.592a.4.4 0 0 1 .692 0l2.803 4.806a.4.4 0 0 1-.345.602H6.196a.4.4 0 0 1-.345-.602l2.803-4.806z"
      fill="#fff"
    />
    <path
      d="M14.15 13.63a.4.4 0 0 1 .7 0l4.32 7.776a.4.4 0 0 1-.35.594h-8.64a.4.4 0 0 1-.35-.594l4.32-7.777z"
      fill="#fff"
    />
    <circle cx="7.3" cy="11.8" r="1.8" fill="#fff" />
    <defs>
      <linearGradient id="paint0_linear_1707_59235" x1="1.5" y1="-1" x2="23.5" y2="28" gradientUnits="userSpaceOnUse">
        <stop stop-color="#84C4FF" />
        <stop offset="1" stop-color="#2DA5DC" />
      </linearGradient>
    </defs>
  </svg>
</template>
